import { ButtonLink, Reveal, SectionLabel } from "@/components/common";
import { useFetch } from "@/lib/api";
import { openResume } from "@/lib/site";

export const Opportunities = ({ settings }) => {
  const { data } = useFetch("/roles");
  return (
    <section id="opportunities" data-testid="opportunities-section" className="inverse py-24 md:py-36">
      <div className="container-x">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-6">
            <SectionLabel number="06">Careers</SectionLabel>
            <h2 className="mt-6 font-display text-4xl leading-[1] sm:text-5xl lg:text-6xl">{settings.opportunities.title}</h2>
          </div>
          <p className="self-end text-base leading-relaxed text-silver md:col-span-5 md:col-start-8 md:text-lg">{settings.opportunities.intro}</p>
        </div>
        <ul className="mt-16 grid grid-cols-1 gap-px overflow-hidden border border-line/15 bg-line/15 sm:grid-cols-2 lg:grid-cols-3" data-testid="roles-list">
          {(data || []).map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.05} className="h-full">
              <li className="group flex h-full items-start gap-5 bg-canvas p-6 transition-colors duration-300 hover:bg-surface md:p-8" data-testid={`role-${r.slug}`}>
                <span className="font-mono text-xs text-gold">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <p className="font-display text-2xl leading-tight transition-colors duration-300 group-hover:text-turq">{r.name}</p>
                  <p className="mt-2 text-sm text-silver">{r.focus}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ul>
        <div className="mt-12 flex flex-wrap gap-3">
          <ButtonLink to="/contact?type=employment" testId="opportunities-recruiting-inquiry">Recruiting Inquiry</ButtonLink>
          <ButtonLink to="/contact?type=employment&project=portfolio" variant="secondary" testId="opportunities-request-portfolio">Request Portfolio</ButtonLink>
          <ButtonLink onClick={() => openResume(settings)} variant="gold" testId="opportunities-download-resume">Download Résumé</ButtonLink>
        </div>
      </div>
    </section>
  );
};
